import * as fs from "../utils/formStateUtils";

/* 새 필드 객체 생성 편의 함수 */
export const createNewField = fs.createNewField;

/*
 * 행에 새 필드를 추가하면서 동시에 새 필드 객체를 생성한다.
 * 반환값으로 { updatedStructure, newField } 형태를 돌려준다.
 */
export const addField = (
  formStructure,
  rowId,
  fieldType = "text",
  column = null
) => {
  if (!formStructure)
    return { updatedStructure: formStructure, newField: null };

  // 새 필드 객체 생성
  const newField = fs.createNewField(fieldType);
  if (column) newField.column = column; // two-column 레이아웃용

  // 행에 필드 추가
  const updatedStructure = fs.addFieldToRow(formStructure, rowId, newField);

  return { updatedStructure, newField };
};

/* 필드 삭제 */
export const deleteField = fs.deleteField;

/* 필드 속성 업데이트 */
export const updateFieldProperties = fs.updateFieldProperties;

/* 필드 이동 (다른 행/컬럼으로) */
export const moveField = fs.moveField;

/* 필드 의존성(조건부 표시) 설정/업데이트 */
export const updateFieldDependency = fs.updateFieldDependency;

/* 필드 의존성 제거 */
export const removeFieldDependency = fs.removeFieldDependency;

/* 필드 ID 변경 */
export const renameFieldId = fs.renameFieldId;

/* 기타 편의 래퍼 */
export const getAllFieldIds = fs.getAllFieldIds;
export const getAllFieldIdsAsStrings = fs.getAllFieldIdsAsStrings;
export const getAllFieldsInfo = fs.getAllFieldsInfo;
